export function getUserAvatarLabel(user) {
  const rawValue =
    user?.username?.trim() ||
    user?.name?.trim() ||
    user?.email?.trim() ||
    '';

  if (!rawValue) {
    return '';
  }

  const localValue = rawValue.includes('@') ? rawValue.split('@')[0] : rawValue;
  const normalized = localValue.replace(/[_\-.]+/g, ' ').trim();
  const parts = normalized.split(/\s+/).filter(Boolean);

  if (parts.length >= 2) {
    return `${parts[0][0] ?? ''}${parts[1][0] ?? ''}`.toUpperCase();
  }

  return localValue.slice(0, 2).toUpperCase();
}
